// extracted by mini-css-extract-plugin
export default {"button":"AuthButton-module__button__weYaj","variant":"AuthButton-module__variant__1i8tM","filled":"AuthButton-module__filled__mHWpc"};